import React from "react";
import D3blackbox from "./D3blackbox";
import * as d3 from "d3";
import Axis from "./Axis";
import moment from "moment";

//const Barchart2 = D3blackbox(function(anchor, props, state) {
class Barchart2 extends React.Component {
  render() {
    //console.log("INSIDE BARCHART DATA RECEIVED:");
    let forecasts = this.props.data.forecasts;
    console.log("forecasts: " + forecasts);

    let listforecasts = <span>Empty</span>;
    /*
  if (this.props.data.forecasts) {
    listforecasts = this.props.data.forecasts.map(forecast => (
      <span>{forecast.id}</span>
    ));
  }
*/

    //comparisonValue
    var compareValue = this.props.compareValue;
    var NoForecasts = this.props.data.forecasts.length;
    var locationName = this.props.data.name;

    var maxTEMP = d3.max(forecasts, function(d) {
      return d[compareValue];
    });

    var minTEMP = d3.min(forecasts, function(d) {
      return d[compareValue];
    });

    var svg = d3.select(this.anchor.current),
      margin = { top: 40, right: 20, bottom: 30, left: 40 },
      width = +this.props.width - margin.left - margin.right,
      height = +this.props.height - margin.top - margin.bottom;

    var dateScale = d3
      .scaleTime()
      .domain([new Date("2016-10-01"), new Date("2016-10-31")])
      .rangeRound([0, 600]);

    var x = d3
      .scaleBand()
      .rangeRound([0, width])
      .padding(0.1);

    x.domain(
      forecasts.map(function(d, index) {
        return d.dt;
      })
    );

    var y = d3.scaleLinear().rangeRound([height, 0]);

    y.domain([
      0,
      40
      /*
    d3.max(forecasts, function(d) {
      return d[compareValue];
    })
    */
    ]);

    var g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var xScale = d3
      .scaleLinear()
      //.domain([0, d3.max(dummyLineChartData.days, function(d) { return d[2]; })])
      .domain([0, 40])
      //.range([0, width]);
      .rangeRound([0, width - 20]);

    var foo = [];
    var timeArr = [];
    for (var i = 1; i <= 40; i++) {
      foo.push(i);
    }

    forecasts.map(function(d, index) {
      var formattedTime = moment.unix(d.dt).format("hhA");

      timeArr.push(formattedTime);
      console.log(
        "DATE No " + index + " IS: " + d.dt + " formattedTime= " + formattedTime
      );
    });

    var xAxis = d3.axisBottom(xScale).tickValues(foo);

    g.append("g")
      .attr("class", "axis axis--x")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    g.append("g")
      .attr("class", "axis axis--y")
      .call(d3.axisLeft(y).tickValues([0, 10, 20, 30, 40]))
      //.call(d3.axisLeft(y).ticks(5))
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 6)
      .attr("dy", "0.71em")
      .attr("text-anchor", "end")
      .text("Frequency");

    // Create Bars
    g.selectAll(".bar")
      .data(forecasts)
      .enter()
      .append("rect")
      //.attr("class", "bar")
      //check if it is max temp
      .attr("class", function(d) {
        if (d[compareValue] == maxTEMP) {
          return "max-temp-bar";
        } else if (d[compareValue] == minTEMP) {
          return "min-temp-bar";
        } else {
          return "bar";
        }
      })
      .attr("x", function(d) {
        return x(d.dt);
      })
      .attr("y", function(d) {
        return y(d[compareValue]);
      })
      .attr("width", x.bandwidth())
      .attr("height", function(d) {
        return height - y(d[compareValue]);
      });

    // Ad text to bars with value - NOT WORKING!!!!
    g.selectAll(".bar")
      .append("text")
      .attr("class", "bar-text")
      .attr("x", d => x(d.dt) + x.bandwidth() / 2)
      //.attr("y", 50)
      //.attr("y", 0)
      .attr("y", d => y(d[compareValue]) + 30)
      //.attr("fill", "#ff0000")
      .attr("text-anchor", "middle")
      .text(d => d[compareValue]);

    // Weather images
    g.selectAll(".img")
      .data(forecasts)
      .enter()
      .append("svg:image")
      .attr("x", function(d) {
        return x(d.dt);
      })
      .attr("y", -20)
      .attr("width", 20)
      .attr("height", 24)
      .attr("xlink:href", function(d) {
        return "http://openweathermap.org/img/wn/" + d.icon + "@2x.png";
      })
      .on("mouseover", handleMouseOver)
      .on("mouseout", handleMouseOut);

    // Title Label
    g.append("text")

      .text(
        locationName + " compareValue=" + compareValue
        //+ NoForecasts +
        // " MaxTemp: " +
        // maxTEMP
      )
      .attr("transform", "translate(0, -20)");

    function handleMouseOver(d, i) {
      // Add interactivity
      // Use D3 to select element, change color and size
      d3.select(this)
        .transition()
        .attr("width", 60)
        .attr("height", 72)
        .attr("x", function(d) {
          return x(d.dt) - 20;
        })
        .attr("y", -44);
    }

    function handleMouseOut(d, i) {
      // Use D3 to select element, change color back to normal
      d3.select(this)
        .transition()
        .attr("width", 20)
        .attr("height", 24)
        .attr("x", function(d) {
          return x(d.dt);
        })
        .attr("y", -20);
    }
    return svg;
  }
}

export default Barchart2;
